
<template>
  <v-container fluid class="px-5 pt-3">
    <v-row class="pa-3" align='center'>
      <span class="title font-weight-bold">{{ $t('financials.financial') }}</span>
      <v-spacer></v-spacer>
      <v-btn color="primary" v-if="false" elevation="0" small class="text-capitalize font-weight-bold" style="border-radius: 5px;" :to="{name: 'NewMovement'}" >
        <v-icon left small>mdi-plus</v-icon>
        {{ $t('financials.financial') }}
      </v-btn>
    </v-row>
    <!-- <base-page-title title="Cadastro de Cliente">
      <template v-slot:actions>
        <f-btn alt_label="Cadastrar de Cliente" alt_icon="mdi-plus"></f-btn>
      </template>
    </base-page-title> -->
    <movement-list class="mt-5"></movement-list>

    <router-view></router-view>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import MovementList from '../../components/movements/MovementList.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'MovementListPage',
  //mixins: [ validations ],
  components: {
    MovementList
    //ComponentName: () => import(''),
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>